import { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Alert, Button, Card, CardContent, CardHeader, Dialog, DialogContent, Stack, TextField, Typography } from '@mui/material';
import * as ws from './web-services';
import { MemberDTO } from './data-types';
import logo from './images/ctalogo.jpg';
import { Height, Padding } from '@mui/icons-material';
import zIndex from '@mui/material/styles/zIndex';

const bgStyle = {
  background: 'linear-gradient(154.04deg, #1743A6 41.41%, #9719B1 82.72%, #AC1BB9 95.9%)',
  backgroundRepeat: 'no-repeat',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundSize: 'cover',
  zIndex: -1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

interface MyProps {
  memberDTO: MemberDTO;
  setMemberDTO: (memberDTO: MemberDTO) => void;
}

function SearchForm({ memberDTO, setMemberDTO }: MyProps) {
  const [searchValID, setSearchValID] = useState<string>('');
  const [searchValZip, setSearchValZip] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [initComplete, setInitComplete] = useState<boolean>(false);
  const [showValidationError, setShowValidationError] = useState(false);

  const regex = /^\d+$/;

  const isMemberIDValid = (val: string) => {
    if (regex.test(searchValID) && searchValID.length >= 6 && searchValID.length <= 10) {
      return true;
    } else {
      return false;
    }
  }

  const isZipValid = (val: string) => {
    if (regex.test(searchValZip) && searchValZip.length === 5) {
      return true;
    } else {
      return false;
    }
  }

  const getMemberData = async () => {
    console.log(searchValID, searchValZip);
    if (searchValID === '' || searchValZip === '')
      return;

    if (!isMemberIDValid(searchValID)) {
      setShowValidationError(true);
      return;
    }
    if (!isZipValid(searchValZip)) {
      setShowValidationError(true);
      return;
    }

    setMemberDTO({ ...memberDTO });
    setIsLoading(true);
    try {
      const res = await ws.getMemberDTOByIndividualID(searchValID, searchValZip);
      setMemberDTO(res.data);
      setIsLoading(false);
    } catch (err) {
      setInitComplete(false);
      alert('ERROR CALLING WS' + err.message);
    } finally {
      setInitComplete(true);
      setIsLoading(false);
    }
  }


  return (
    <div style={bgStyle}>
      <Card style={{ paddingLeft: 40, paddingRight: 40, width: 470, boxSizing: 'border-box' }} elevation={1} >
        <CardHeader sx={{ paddingBottom: 0, paddingLeft: 0, paddingRight: 0 }}
          title={<img src={logo} className="App-logo" alt="logo" />}
        />
        <CardContent sx={{ padding: 0 }}>
          <Stack spacing={2}  >

            <Typography >
              To find your sign-in method, please enter your CTA Member ID and Zip Code below
            </Typography>

            <Stack direction={'column'} spacing={1.5}  >
              <TextField value={searchValID} onChange={(e) => setSearchValID(e.target.value)}
                size='small' label='Member ID' fullWidth type='number'
                error={showValidationError && !isMemberIDValid(searchValID)}
                helperText={showValidationError && !isMemberIDValid(searchValID) ? 'Must contain between 6 and 10 digits.' : ''}
              />
              <TextField value={searchValZip} onChange={(e) => setSearchValZip(e.target.value)}
                size='small' label='Zip Code' fullWidth type='number'
                error={showValidationError && !isZipValid(searchValZip)}
                helperText={showValidationError && !isZipValid(searchValZip) ? 'Must contain 5 digits.' : ''}
              />
              <Button variant="contained" endIcon={<SearchIcon />} onClick={getMemberData} fullWidth style={{ textTransform: 'none' }} >
                Search
              </Button>
            </Stack>
            {!initComplete || isLoading ? <Stack></Stack>
              :
              !memberDTO.isValidMemberID ?
                <Stack>
                  <Alert severity="error">This member ID does not exist.</Alert>
                </Stack>
                : !memberDTO.isZipValid &&
                <Stack>
                  <Alert severity="error">Incorrect zip code for this Member ID.</Alert>
                </Stack>
            }

            <Typography>
              Your 10-digit member ID is shown on your membership card and above your name on the mailing label of California Educator magazine.
            </Typography>
            <Typography>
              If you need further assistance with your member ID, please contact membership@cta.org.
            </Typography>

          </Stack>
          {isLoading &&
            <Dialog open={isLoading}>
              <DialogContent>
                Loading Data...
              </DialogContent>
            </Dialog>
          }
        </CardContent>
      </Card>
    </div>


  );
}


export default SearchForm;
